import React from 'react';
import { shape, string, func } from 'prop-types';
import {
  MESSAGE_TYPE_MEDIA,
  MESSAGE_TYPE_TEXT,
  MESSAGE_TYPE_LOCATION,
  MESSAGE_TYPE_ATTACHMENT,
  MESSAGE_TYPE_FILE,
} from 'Constants/message-types';

import MessageText from './MessageText';
import MessageMedia from './MessageMedia';
import MessageLocation from './MessageLocation';
import MessageAction from './MessageAction/MessageAction';
import MessageFile from './MessageFile';

const MessageItemContent = ({ message, userUuid, openMedicalCertificate }) => {
  switch (message.type) {
    case MESSAGE_TYPE_TEXT: // text
      return (
        <MessageText
          id={`message_${message?.id}`}
          message={message}
          body={message.message.text}
          source={message.metadata.source}
        />
      );
    case MESSAGE_TYPE_MEDIA: // image share
      return <MessageMedia message={message} conversationId={message.metadata.conversationId} />;
    case MESSAGE_TYPE_FILE: // TODO: handle file share
      return <MessageFile message={message} />;
    case MESSAGE_TYPE_LOCATION: // location
      return <MessageLocation message={message} />;
    case MESSAGE_TYPE_ATTACHMENT:
      return (
        <MessageAction
          message={message}
          userUuid={userUuid}
          openMedicalCertificate={openMedicalCertificate}
        />
      );
    default:
      return null;
  }
};

MessageItemContent.propTypes = {
  userUuid: string.isRequired,
  openMedicalCertificate: func.isRequired,
  message: shape({}).isRequired,
};

MessageItemContent.defaultProps = {};

export default MessageItemContent;
